export function isClientError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        typeof error.code === 'string' &&
        typeof error.message === 'string');
}
//# sourceMappingURL=error.types.js.map